var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"cities"}},[_c('card',{attrs:{"icon":"map-marker-alt","headline":_vm.$t('visitors.topCities.headline'),"description":_vm.$t('visitors.topCities.description')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }